import React, { useEffect, useState } from 'react'
import { Typography } from '@material-ui/core';

import TableCustom from '../../../../../../Components/Table';

import { useStyles } from '../styles';
import { formatarReais } from '../../../../../../Utils/utils';

export default function FichaContribuicaoIndevida({ dadosEspelho, modoImprimir = false, modoImprimirTodos = false }) {

    const classes = useStyles();
    const [data, setData] = useState([]);

    useEffect(() => {
        setData([{
            ...dadosEspelho.dadosRestituicao
        }]);
    }, [dadosEspelho])

    const columns = [
        {
            title: "Categoria do Segurado",
            dataIndex: "tipoFiliadoVinculo",
            key: "tipoFiliadoVinculo",
            align: "left",
            width: 100,
            maxWidth: '15%',
            headerRender: (title) => <div style={{ paddingLeft: 12, display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, paddingRight: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13, paddingLeft: 15 }}>{value}</p>,
        },
        {
            title: "Justificativa do Pedido",
            dataIndex: "justificativaPedido",
            key: "justificativaPedido",
            align: "left",
            width: 100,
            maxWidth: '25%',
            headerRender: (title) => <div style={{ display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value}</p>,
        },
        {
            title: "Valor do Pedido de Restituição",
            dataIndex: "valorCredito",
            key: "valorCredito",
            align: "left",
            width: 100,
            maxWidth: '20%',
            headerRender: (title) => <div style={{ display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value !== '-' ? formatarReais(value) : '-'}</p>,
        },
        {
            title: "",
            dataIndex: "",
            key: "null",
            width: 80,
            render: (value, row) => <p style={{ fontSize: 13 }}>{''}</p>,
        },
    ];

    const propsTable = {
        columns,
        data,
        heightBody: "auto",
        minHeightBody: "auto",
        marginBorder: false,
        usarMarginBottomContainer: true,
        width: '98%',
        hideBorderBottom: true,
        ativarHoverLinha: false,
        elevationPaper: 0,
        optionsToolbar: {
            info: (
                <div className={classes.header}>
                    <div className={classes.col1}>
                        <div>
                            <Typography className={classes.headerTitle}>{'Ficha Contribuição Previdenciária Indevida ou a Maior'}</Typography>
                        </div>
                    </div>
                </div>
            ),
        },
    };

    return (
        <div style={{ height: (modoImprimirTodos ? '68vh' : (modoImprimir ? '45vh' : 'auto')) }}>
            <TableCustom {...propsTable} />
        </div>
    )
}
